import script from "./submitOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./submitOrder.vue?vue&type=script&setup=true&lang=js"

import "./submitOrder.vue?vue&type=style&index=0&id=2dad07e1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dad07e1"]])

export default __exports__